<app-layout-first-level>
  <app-layout-title>
    {{ 'app.notifications.page.title' | translate }}
  </app-layout-title>
  <app-layout-content>
    <app-notification-list></app-notification-list>
  </app-layout-content>
</app-layout-first-level>
